import router from "@/router";
import axios from "axios";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { localCache } from "@/utils/Cache";
import { delCookie } from "@/utils/delCookie";
import qs from "qs";
import menu from "@/store/menu";
import { getCookie } from "@/utils/getCookie";
import store from "@/store";

axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded";
// axios.defaults.withCredentials = true;
let ajaxElVm = null;
let hit = 0;
let isShow = false;
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    hit++;
    config.headers["satoken"] = getCookie("vr_platform");
    if (config.url?.indexOf("/pc/admin/sign/in/checkQrcode") == -1) {
      if (hit === 1 && !ajaxElVm) {
        ajaxElVm = ElNotification({
          lock: true,
          duration: 0,
          message: "数据请求中...",
          iconClass: "el-icon-loading",
          customClass: "el-notify--ajax",
          background: "rgba(0,0,0, 0.3)",
          position: "bottom-right",
        });
      }
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    hit--;
    if (res.data && res.config?.responseType == "blob") {
      if (res.data.type === "application/json") {
        const reader = new FileReader();
        reader.readAsText(res.data, "utf-8");
        reader.onload = function () {
          const _res = JSON.parse(reader.result);
          if (_res.code == 500) {
            ElMessage.error(_res.msg);
            return Promise.reject(_res.msg);
          }
          // 此处为接口返回值
        };
      }
      return res;
    }
    setTimeout(() => {
      if (hit === 0 && ajaxElVm) {
        ajaxElVm.close();
        ajaxElVm = null;
      }
    }, 800);
    if (res.data.code === 500 || res.data.code == 123) {
      ElMessage.error(res.data.msg);
      return Promise.reject(res.data.msg);
    } else if (res.data.code == 401) {
      ElMessage.error(res.data.msg);
    } else if (res.data.code == 501) {
      if (!isShow) {
        isShow = true;
        ElMessageBox.confirm("登陆已过期,请重新登录", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            isShow = true;
            delCookie("vr_platform");
            const userData =
              localCache.getCache("userData") &&
              JSON.parse(localCache.getCache("userData"));
            if (userData?.tenantUuid == "118eeeafa0414d2c8811e78039c8cfc9") {
              // 艺术学院
              window.open(store.state.menu.ysxyUrl, "_self");
            } else if (
              userData?.tenantUuid == "dcd33dd948c846a6aa8ff0b84d80f9e9"
            ) {
              // 美视电影学院
              window.open(store.state.menu.msxyUrl, "_self");
            } else {
              // 初始平台
              window.open(store.state.menu.ownUrl, "_self");
            }
            localCache.clearCache();
          })
          .catch(() => {
            isShow = false;
          });
      }
    } else if (res.data.code == 505) {
      ElMessageBox.confirm("您已被挤下线啦，请重新登录", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const userData =
            localCache.getCache("userData") &&
            JSON.parse(localCache.getCache("userData"));
          if (userData?.tenantUuid == "118eeeafa0414d2c8811e78039c8cfc9") {
            // 艺术学院
            window.open(store.state.menu.ysxyUrl, "_self");
          } else if (
            userData?.tenantUuid == "dcd33dd948c846a6aa8ff0b84d80f9e9"
          ) {
            // 美视电影学院
            window.open(store.state.menu.msxyUrl, "_self");
          } else {
            // 初始平台
            window.open(store.state.menu.ownUrl, "_self");
          }
          delCookie();
          localCache.clearCache();
        })
        .catch(() => {});
    } else if (res.data.code == 101) {
      router.push({ path: "/error" });
    } else if (res.data.code == 199) {
      router.push({ path: "/noperssion" });
    } else if (res.data.code == 200) {
      return res.data;
    } else {
      ElMessage.error(res.data.msg);
      return Promise.reject(res.data.msg);
    }
  },
  (err) => {
    hit--;
    setTimeout(() => {
      if (hit === 0 && ajaxElVm) {
        ajaxElVm.close();
        ajaxElVm = null;
      }
    }, 800);
    ElMessage.error(err.response.data.msg);
    return Promise.reject(err);
  }
);
export default axios;
